import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=2781f90f"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2781f90f')) {
      api.createRecord('2781f90f', component.options)
    } else {
      api.reload('2781f90f', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=2781f90f", function () {
      api.rerender('2781f90f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/admin-roles/manage.vue"
export default component.exports